<template>
  <DataList
    title="Завдання"
    resource="projects-issues"
    :columns="columns"
    :get-items-fn="getIssues"
    :filter="filter"
    :chips-color-fn="getIssueStatusColorClass"
  >
    <template v-slot:filters>
      <v-row
        dense
        justify="center"
      >
        <v-col>
          <ProjectSelect
            v-model="issueProjectFilter"
            class="pr-1"
            @input="isChanged = true"
          />
        </v-col>
        <v-col>
          <UserSelect
            v-model="issueImplementerFilter"
            :multiple-select="false"
            label="Виконавець"
            placeholder="Введіть iм’я виконавця"
          />
        </v-col>
        <v-col cols="3">
          <EnumSelect
            v-model="issueStatusFilter"
            :items="issueStatuses"
            label="Статус"
            placeholder="Виберіть статус задачі"
            clearable
            :hide-details="true"
          />
        </v-col>
      </v-row>
    </template>
  </DataList>
</template>

<script>
import * as issuesApi from "../../backend/issuesApi.js";
import IssueStatuses from "../../helpers/issueStatuses.js";
import EnumSelect from "@/components/selects/EnumSelect";
import ProjectSelect from "../projects/ProjectSelect.vue";
import UserSelect from "../../../views/system/users/UserSelect.vue";

export default {
  components: {
    EnumSelect,
    ProjectSelect,
    UserSelect,
  },
  data: () => ({
    columns: [
      //{ title: "id", name: "id", dataPath: "id" },
      { title: "Дата", name: "date" },
      { title: "Проекты", name: "project" },
      { title: "Автор", name: "creator" },
      { title: "Исполнитель", name: "implementer" },
      { title: "Описание", name: "title" },
      { title: "Кплан", name: "planDate" },
      { title: "Витрачений час", name: "logWorks" },
      { title: "Статус", name: "status", isColoredChip: true, width: 150 },
    ],
    issueStatusFilter: null,
    issueProjectFilter: null,
    issueImplementerFilter: null,
  }),
  computed: {
    issueStatuses(){
      return [
        {
          value: IssueStatuses.TO_DO.value,
          text: IssueStatuses.TO_DO.title,
        },
        {
          value: IssueStatuses.DISPUTE.value,
          text: IssueStatuses.DISPUTE.title,
        },
        {
          value: IssueStatuses.IN_PROGRESS.value,
          text: IssueStatuses.IN_PROGRESS.title,
        },
        {
          value: IssueStatuses.DONE.value,
          text: IssueStatuses.DONE.title,
        },
      ];
    },
    filter() {
      return {
        issueStatusFilter: {
          id: this.issueStatusFilter ?? "",
        },
        issueProjectFilter: {
          id: this.issueProjectFilter?.id || "",
          title: this.issueProjectFilter?.title || "",
        },
        issueImplementerFilter: {
          id: this.issueImplementerFilter?.id || "",
          title: this.issueImplementerFilter?.title || "",
        },
      };
    },
    filterParams() {
      return `filter.issueStatusId=${this.filter?.issueStatusFilter?.id ?? ""}
              &filter.issueProjectId=${this.filter?.issueProjectFilter?.id ?? ""}
              &filter.issueImplementerId=${this.filter?.issueImplementerFilter?.id ?? ""}`;
    },
  },
  created() {
  },
  methods: {
    async getIssues(...args) {
      const issues = await issuesApi.getIssues(args[0], args[1], args[2], args[3]);

      issues.result = issues.result.map(issue=>{
        return {
          id: issue.id,
          title: issue.title,
          description: issue.description,
          date: issue.date,
          project: issue.project != null ? issue.project.title : "",
          planDate: issue.planDate,
          status: this.getIssueStatus(issue.status),
          implementer: issue.implementer != null ? issue.implementer.title : "",
          creator: issue.creator != null ? issue.creator.title : "",
          logWorks: issue.logWorks,
        };
      });
      return issues;
    },
    getIssueStatus(status){
      switch (status){
        case 1: return IssueStatuses.TO_DO.title;
        case 2: return IssueStatuses.DISPUTE.title;
        case 3: return IssueStatuses.IN_PROGRESS.title;
        case 4: return IssueStatuses.DONE.title;
        default: return "";
      }
    },
    getIssueStatusColorClass(item, estimateName){
      switch (item[estimateName]){
        case "ToDo": return "blue-grey";
        case "Dispute": return "yellow";
        case "InProgress": return "light-blue";
        case "Done": return "green";
        default: return "";
      }
    },
  },
};
</script>